var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('s-text',{attrs:{"autofocus":"","label":_vm.label,"search-icon":""},on:{"clearable":function($event){return _vm.clearable($event)},"keyupEnter":function($event){return _vm.keyupEnter($event)}},model:{value:(_vm.BosOV),callback:function ($$v) {_vm.BosOV=$$v},expression:"BosOV"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }